import { useModuleRedirect } from "../../hooks/useModuleRedirect";

const SafetyFacilityRoundsEntry = () => {
  useModuleRedirect("safety-facility-rounds-module");
  return null;
};

export default SafetyFacilityRoundsEntry;
